module.exports = __webpack_public_path__ + "static/img/icon_xinmi@2x.cf88dda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_xinmi@2x.png
// module id = Uvl7
// module chunks = 0